import { NgOptimizedImage } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { NavService } from '../nav/service/nav.service';

@Component({
  selector: 'app-not-found',
  imports: [NgOptimizedImage],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
})
export class NotFoundComponent implements OnInit {
  private navService = inject(NavService);

  ngOnInit(): void {
    this.navService.setGreenBackground();
  }
}
